// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-green {
  color: green;
}
#eye-dropper-overlay {
  overflow: hidden;
}
a {
  text-decoration: none !important;
}
.bg-biscuit {
  background-color: #fffee1;
}
.relative {
  position: relative;
}
.eye3 {
  position: absolute;
  top: -27px;
  right: 15px;
  cursor: pointer;
}
input:focus {
  outline: none !important;
}
span {
  color: #000 !important;
}

.google-login-wrapper {
  box-shadow: 1px 2px 3px gray !important;

  display: flex;
  padding: 0.3rem;
}

@media (max-width: 844px) {
  body {
    height: 100vh;
  }
  .left_side {
    height: 100vh !important;
    background: #ffffff !important;
  }
  label {
    color: #050505 !important;
  }
  .auth {
    background: #466657 !important;
  }
  input {
    outline: 1.5px solid #cccccc;
    transition: outline 0.2s ease-in-out;
  }

  input:focus {
    outline: 2px solid #007bff;
  }

  .custom-google-login-button {
    width: 100%;
    height: 50px;
    background-color: rgb(244 242 237) !important;
    color: black;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    gap: 10px;
    align-items: center;
  }
}
.custom-google-login-button {
  width: 100%;
  height: 50px;
  background-color: rgb(244 242 237) !important;
  color: black;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Auth/styles.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;;EAEvC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,oCAAoC;EACtC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,6CAA6C;IAC7C,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB","sourcesContent":[".text-green {\n  color: green;\n}\n#eye-dropper-overlay {\n  overflow: hidden;\n}\na {\n  text-decoration: none !important;\n}\n.bg-biscuit {\n  background-color: #fffee1;\n}\n.relative {\n  position: relative;\n}\n.eye3 {\n  position: absolute;\n  top: -27px;\n  right: 15px;\n  cursor: pointer;\n}\ninput:focus {\n  outline: none !important;\n}\nspan {\n  color: #000 !important;\n}\n\n.google-login-wrapper {\n  box-shadow: 1px 2px 3px gray !important;\n\n  display: flex;\n  padding: 0.3rem;\n}\n\n@media (max-width: 844px) {\n  body {\n    height: 100vh;\n  }\n  .left_side {\n    height: 100vh !important;\n    background: #ffffff !important;\n  }\n  label {\n    color: #050505 !important;\n  }\n  .auth {\n    background: #466657 !important;\n  }\n  input {\n    outline: 1.5px solid #cccccc;\n    transition: outline 0.2s ease-in-out;\n  }\n\n  input:focus {\n    outline: 2px solid #007bff;\n  }\n\n  .custom-google-login-button {\n    width: 100%;\n    height: 50px;\n    background-color: rgb(244 242 237) !important;\n    color: black;\n    border: none;\n    border-radius: 4px;\n    font-size: 16px;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n    align-items: center;\n  }\n}\n.custom-google-login-button {\n  width: 100%;\n  height: 50px;\n  background-color: rgb(244 242 237) !important;\n  color: black;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
